import { AccountProfile } from '#/api/account';

import { LiveConnectionBaseState } from '#/utils/useLiveConnection';

export const INITIAL_STATE: AccountProfileState = {
  status: 'disconnected',
  error: '',
  profile: null,
};

export interface AccountProfileState extends LiveConnectionBaseState {
  readonly profile: AccountProfile | null;
}
